var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.141,
    height: 16.557,
    viewBox: "0 0 14.141 16.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-341.715 -406.498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18462.92,13702.308h-8.562v-1.5h8.563a2,2,0,0,1,3.707,0h1.871v1.5h-1.871a2,2,0,0,1-3.707,0Zm-7.135-6.28h-1.428v-1.5h1.428a2,2,0,0,1,3.711,0h9v1.5h-9a2,2,0,0,1-3.711,0Zm7.135-6.275h-8.562v-1.5h8.563a2,2,0,0,1,3.707,0h1.871v1.5h-1.871a2,2,0,0,1-3.707,0Z",
    transform: "translate(-18112.643 -13280.5)",
    fill: "#dfe1e5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.42dccb9996652bb7fdd95472c5c60993.svg";
export { ForwardRef as ReactComponent };